import { Group, Input, Select } from '@byecode/ui'
import type { FlowNode, NodeTypes, SendWebSocketActionConfig } from '@lighthouse/shared'
import { ListItem4ByecodeUi, nodeTypeOptions } from '@lighthouse/shared'
import React from 'react'

import { VariableListControlled } from '../Common/VariableConfigure/VariableListControlled'
import * as SC from '../styles'

interface SendWebSocketActionConfigureProps {
    actionTypeSwitcher?: React.ReactNode
    nodeType?: NodeTypes
    value: SendWebSocketActionConfig
    allParentNodes?: FlowNode[]
    onChange: (value: SendWebSocketActionConfig) => void
}

export const SendWebSocketActionConfigure: React.FC<SendWebSocketActionConfigureProps> = ({
    actionTypeSwitcher,
    nodeType,
    value,
    allParentNodes,
    onChange
}) => {
    return (
        <SC.Container>
            <Group label="动作配置">
                <ListItem4ByecodeUi>
                    <SC.FormItemLabelWrapper>
                        <SC.FormItemLabel>类型</SC.FormItemLabel>
                    </SC.FormItemLabelWrapper>
                    <SC.FormItemContent>
                        {actionTypeSwitcher || <Select disabled value={nodeType} options={nodeTypeOptions} onChange={() => undefined} />}
                    </SC.FormItemContent>
                </ListItem4ByecodeUi>
            </Group>
            <Group label="传入Websocket的参数">
                <ListItem4ByecodeUi>
                    <SC.FormItemLabelWrapper>
                        <SC.FormItemLabel required>事件参数名</SC.FormItemLabel>
                    </SC.FormItemLabelWrapper>
                    <SC.FormItemContent>
                        <Input value={value?.eventName} onChange={ev => onChange({ ...value, eventName: ev.target.value })} />
                    </SC.FormItemContent>
                </ListItem4ByecodeUi>
                <ListItem4ByecodeUi>
                    <SC.FormItemLabelWrapper>
                        <SC.FormItemLabel required>事件参数值</SC.FormItemLabel>
                    </SC.FormItemLabelWrapper>
                    <SC.FormItemContent>
                        <Input value={value?.eventValue} onChange={ev => onChange({ ...value, eventValue: ev.target.value })} />
                    </SC.FormItemContent>
                </ListItem4ByecodeUi>
                <VariableListControlled
                    hasValue
                    allParentNodes={allParentNodes}
                    value={value?.args}
                    onChange={args => onChange({ ...value, args })}
                />
            </Group>
        </SC.Container>
    )
}
